
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { MailTemplateType } from 'enums/MailTemplateType';
import { Model, ModelProperty } from 'models/Model';


export class MailTemplateModel extends Model<MailTemplateModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'mailTemplate.property.id', isHidden: true },
		{ name: 'mailTemplateType', type: 'MailTemplateType', languageString: 'mailTemplate.property.mailTemplateType' },
		{ name: 'created', type: 'Date', languageString: 'mailTemplate.property.created', isHidden: true },
		{ name: 'title', type: 'string', languageString: 'mailTemplate.property.title' },
		{ name: 'subject', type: 'string', languageString: 'mailTemplate.property.subject' },
		{ name: 'content', type: 'string', languageString: 'mailTemplate.property.content' }
	];
	[key: string]: any;
	
	public id?: string;
	public mailTemplateType: MailTemplateType;
	public created?: Date;
	public title: string;
	public subject: string;
	public content: string;
    
	constructor(){
		super();
		this.id = undefined;
		this.mailTemplateType = 0;
		this.created = undefined;
		this.title = '';
		this.subject = '';
		this.content = '';
		
	}
	getProperties(){
		return MailTemplateModel.classProperties;
	}
}

